var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00364 3.55717L4.89111 0H0L6.22505 7.55899L11.3478 5.44692L8.00364 3.55717Z",
    fill: "#55ACEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1164 0L8.00391 3.55717L10.4006 6.80843L10.9461 6.14635L16.0075 0H11.1164Z",
    fill: "#3B88C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3178 7.1154C10.3534 7.01891 10.3761 6.9162 10.3761 6.80726C10.3761 6.31637 9.97766 5.91797 9.48677 5.91797H6.52231C6.03098 5.91797 5.63302 6.31637 5.63302 6.80726C5.63302 6.9162 5.65525 7.01891 5.69127 7.1154C4.24261 7.92733 3.26172 9.47514 3.26172 11.2537C3.26127 13.8731 5.38491 15.9968 8.00432 15.9968C10.6237 15.9968 12.7474 13.8731 12.7474 11.2537C12.7474 9.47514 11.7665 7.92733 10.3178 7.1154Z",
    fill: "#FFAC33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62755 8.27246H7.86232L6.64843 9.22045C6.62353 9.24535 6.59863 9.31204 6.59863 9.34495V9.86874C6.59863 9.95145 6.66533 10.0261 6.74848 10.0261H7.54662V13.7674C7.54662 13.851 7.61332 13.9253 7.70447 13.9253H8.62755C8.71026 13.9253 8.77696 13.8506 8.77696 13.7674V8.42987C8.77696 8.34716 8.7107 8.27246 8.62755 8.27246Z",
    fill: "#9E5200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.53f02b15fb96d7ede749f7204bb77223.svg";
export { ForwardRef as ReactComponent };